var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex justify-content-between" }, [
            _c("div", [
              _c("p", [
                _vm._v("Всего заявок: "),
                _c("strong", [_vm._v(_vm._s(_vm.paginator?.total ?? 0))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search.name,
                      expression: "search.name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "ФИО" },
                  domProps: { value: _vm.search.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.search, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group-prepend input-group-append" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-info",
                        on: { click: () => _vm.getRecords(1) },
                      },
                      [_vm._v("поиск")]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _vm.adminMode
                ? _c("div", { staticClass: "mr-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.perPage,
                          expression: "perPage",
                        },
                      ],
                      staticClass: "form-control mr-2",
                      attrs: {
                        type: "number",
                        placeholder: "Кол. на странице",
                      },
                      domProps: { value: _vm.perPage },
                      on: {
                        change: _vm.getRecords,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.perPage = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sorting.weight,
                              expression: "sorting.weight",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.sorting.weight)
                              ? _vm._i(_vm.sorting.weight, null) > -1
                              : _vm.sorting.weight,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.sorting.weight,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.sorting,
                                        "weight",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.sorting,
                                        "weight",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.sorting, "weight", $$c)
                                }
                              },
                              _vm.getRecords,
                            ],
                          },
                        }),
                        _vm._v(" добавление веса\n                первыми"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Распечатать стикеры",
                        type: "button",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.PRIMARY_COLOR,
                        onClick: () => _vm.printStickers(),
                        className: "btn btn-sm btn-outline-info mr-2",
                      },
                    }),
                    _vm._v(" "),
                    _c("LoadingButton", {
                      attrs: {
                        title: "Создать файл для почты",
                        type: "button",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.SUCCESS_COLOR,
                        onClick: () => _vm.generateImport(),
                        className: "btn btn-sm btn-outline-success",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          !_vm.loading && _vm.records
            ? [
                _c("SimpleOrderList", {
                  ref: "ordersList",
                  attrs: {
                    orders: _vm.records,
                    drugsImages: _vm.drugsImages,
                    paginator: _vm.paginator,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 5,
                            "margin-pages": 4,
                            "click-handler": _vm.getRecords,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }